import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import {
  RecommendationsState,
  RecommendationsApiResponse,
  RecommendationsDetailsApiResponse,
} from '../types';

const initialState: RecommendationsState = {
  recommendations: [],
  recommendationsDetails: undefined!,
  currentPage: 0,
  itensPerPage: 0,
  totalPages: 0,
};

const recommendationsSlice = createSlice({
  name: 'recommendations',
  initialState,
  reducers: {
    setRecommendationsAction(state, action: PayloadAction<RecommendationsApiResponse>) {
      state.recommendations = action.payload.recommendations;
      state.currentPage = action.payload.currentPage;
      state.itensPerPage = action.payload.itensPerPage;
      state.totalPages = action.payload.totalPages;
    },

    clearRecommendationsAction(state) {
      state.recommendations = [];
    },

    setRecommendationsDetailsAction(
      state,
      action: PayloadAction<RecommendationsDetailsApiResponse>
    ) {
      state.recommendationsDetails = action.payload;
    },

    clearRecommendationsDetailsAction(state) {
      state.recommendationsDetails = undefined!;
    },
  },
});

export const {
  setRecommendationsAction,
  clearRecommendationsAction,
  setRecommendationsDetailsAction,
  clearRecommendationsDetailsAction,
} = recommendationsSlice.actions;

export const getRecommendationsService = (state: RootState): RecommendationsState =>
  state.recommendations;

export default recommendationsSlice.reducer;
